module.exports = __webpack_public_path__ + "img/logo.ab3dffe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/footer/logo.png
// module id = 358
// module chunks = 0